import { struct } from 'io-ts/Decoder';

import { Id as CanvasId } from '../../../../../whole-house/canvas/Id';
import { Id as CanvasRecipeId } from '../../../../../whole-house/canvas/recipe/Id';

export const Params = struct({
	canvasId: CanvasId,
	canvasRecipeId: CanvasRecipeId,
});
